import { render, staticRenderFns } from "./UpdateArtistPlan.vue?vue&type=template&id=08a039c3&scoped=true&"
import script from "./UpdateArtistPlan.vue?vue&type=script&lang=js&"
export * from "./UpdateArtistPlan.vue?vue&type=script&lang=js&"
import style0 from "./UpdateArtistPlan.vue?vue&type=style&index=0&id=08a039c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a039c3",
  null
  
)

export default component.exports